import React, { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { GeometryType, ResourceTypeLink } from "@evergis/api";
import { Icon } from "@evergis/ui";

import { LayerSlideCard, ObjectsCountContainer, SlideCard } from "./styled";
import { geometryTypes } from "../../../../evergis/core/attributes/geometryTypes";
import { useLayerPreview } from "../../../../hooks/preview/usePreview";
import { useAddLayersToCurrentProject } from "../../../../hooks/project/useAddLayersToCurrentProject";
import { usePreviewSrc } from "../../../Catalog/hooks/usePreviewSrc";
import { getCardFallback } from "../../../Catalog/components/Card/utils";

export type SlideData = {
  alias: string;
  name: string;
  preview: string;
  type: string;
  geometryType: GeometryType;
};

type ProjectSlideProps = {
  item: SlideData;
};

export const LayerSlide: FC<ProjectSlideProps> = ({ item }) => {
  const { t } = useTranslation("common");
  const { alias, preview, geometryType, name } = item;
  const geometryTypeOption = useMemo(() => geometryTypes.find(({ value }) => value === geometryType), [geometryType]);
  const { langKey, icon } = geometryTypeOption;
  const addLayers = useAddLayersToCurrentProject();
  const [layerPreview] = useLayerPreview(name);
  const previewSrc = usePreviewSrc(layerPreview, preview);
  const addLayerToProject = useCallback(() => {
    addLayers([item]);
  }, [addLayers, item]);

  return (
    <LayerSlideCard onClick={addLayerToProject}>
      <SlideCard
        width={"100%"}
        imageHeight="5rem"
        header={alias}
        imageSource={previewSrc}
        imageGradient={!!previewSrc}
        fallback={getCardFallback(item, ResourceTypeLink.Layer)}
        clickable
        noControls
        additionalBlock={
          <ObjectsCountContainer>
            <Icon title={t(langKey)} kind={icon} />
          </ObjectsCountContainer>
        }
      />
    </LayerSlideCard>
  );
};
